export default __webpack_public_path__ + "static/media/gucci_x_mad_2.5739b24b.png";